import styled from "styled-components";

export const ViewScenePageStyle = styled.div`
  p {
    padding: 5px;
  }
`;
